export default "__VITE_ASSET__BoTrydRt__"